/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";
import bio from "./bio.js"
const illustration = {
  animated: true // set to false to use static SVG
};
const greeting = {
  username: "Youness Srhir",
  title: "Bonjour je m'appelle Youness Srhir",
  subTitle: bio,
  resumeLink:
    "https://www.canva.com/design/DAEXgKqx69U/B___zIzqE3vsBbRtOkv5EA/view?utm_content=DAEXgKqx69U&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Littleyounes/",
  linkedin: "https://www.linkedin.com/in/youness-srhir-6788a819b/",
  gmail: "ysrhir@hotmail.fr",

  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc:
        "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Clever Programmer",
      companylogo: require("./assets/images/cpLogo.png"),
      date: "September 2020 – Present",
      desc:
        "Changing lives of developers one line of code at a time.",
      descBullets: [
        "Custom building applications",
        "Coaching",
        "Streaming live on YouTube",
        "Creating tutorials"
      ]
    },
    {
      role: "Product Owner (PSD2)",
      company: "Erste Bank",
      companylogo: require("./assets/images/ersteLogo.jpg"),
      date: "July 2019 – September 2020",
      desc:
        "I lead software developers building the API for the bank in order to fulfil the PSD2 regulation requirements."
    },
    {
      role: "Junior Information Security & Systems Representative",
      company: "Vodafone",
      companylogo: require("./assets/images/vodafoneLogo.png"),
      date: "November 2018 – July 2019",
      desc:
        "I've conducted internal audit making sure the organization is compliant with the GDPR."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "Littleyounes", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projets",
  subtitle: "Quelques projets que j'ai eu à réaliser",
  projects: [
    {
      image: require("./assets/images/lol3.PNG"),
      projectName: "Projet Text Mining",
      projectDesc: "Un projet qui permet d'extraire un maximum d'informations grâce à des procédés complexes de text mining et de machine learning, le tout implémenté dans une interface Web",
      footerLink: [
        {
          name: "Live site (en cours)",
          url: "fa"
        },
        {
          name: "Code Source",
          url: "https://github.com/Littleyounes/Web-Topic-Modeling"
        },
        {
          name: "Design de l'application",
          url: "https://www.canva.com/design/DAEXIPD3psI/ItVhAy0etA8SzD86pasJdA/view?utm_content=DAEXIPD3psI&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink"
        },
        //  you can add extra buttons here.
      ]
    },
    
    
  ],
  display: true // Set false to hide this section, defaults to true
};
const bigProjects2 = {
  title: "",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/lol5.PNG"),
      projectName: "Morpion + Ai",
      projectDesc: "Un jeu de morpion invincible réalisé avec JavaFX, et doté d'une intelligence artificielle codée avec un algorithme de type MinMax",
      footerLink: [
        {
          name: "Code Source",
          url: "fa"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/lol6.PNG"),
      projectName: "Jeu de type plate-forme (Global Game Jam 2021) ",
      projectDesc: "Un mini jeu de de type plate-forme que j'ai réalisé lors de la Global Game Jam, en temps limité (48 heures)",
      footerLink: [
      
        {
          name: "Code Source",
          url: "https://github.com/Littleyounes/YounesAdventure"
        }
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};
const bigProjects3 = {
  title: "",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/lol7.PNG"),
      projectName: "Covid tracker",
      projectDesc: "Petite page affichant plusieurs informations sur l'évolution de la pandémie, fait avec ReactJS, chartJS, Leafletmap, et en utilisant l'api de deseases.sh",
      footerLink: [
        {
          name: "Code Source",
          url: "https://github.com/Littleyounes/Covid-Tracker"
        },
        {
          name: "Live site",
          url: "https://younes-covtrck-53c335.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/lol4.PNG"),
      projectName: "WhatsApp Clone",
      projectDesc: "Reproduire le design d'applications existantes m'a permis de maîtriser différentes technologies web",
      footerLink: [
        {
          name: "Live site",
          url: "https://webwhatsappclone.herokuapp.com/"
        },
        {
          name: "Code Source",
          url: "https://github.com/Littleyounes/WhatsAppWebClone"
        }
      ]
    },
    
  ],
  display: true // Set false to hide this section, defaults to true
};


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications"),
  subtitle:
    "Quelques certifications que j'ai ramassé dans ma quête d'apprentissage",

  achievementsCards: [
    {
      title: "Responsive Web Design (FreeCodeCamp)",
      subtitle: "Developer Certification, representing approximately 300 hours of coursework.",
      image: require("./assets/images/fcc.png"),
      footerLink: [
        {name: "verify certification", url: "https://freecodecamp.org/certification/littleyounes/responsive-web-design"},
          {name: "Projet final 1",
          url: "https://codepen.io/Littleyounes/full/abZOeKL"
        },
        {name: "Projet final 2",
          url: "https://codepen.io/Littleyounes/full/gOMpvXP"
        },
        {name: "Projet final 3",
          url: "https://codepen.io/Littleyounes/full/QWEbMrj"
        }
        
      ]
    },{
      title: "JavaScript Algorithms and Data Structures (FreeCodeCamp)",
      subtitle: "Developer Certification, representing approximately 300 hours of coursework.",
      image: require("./assets/images/fcc.png"),
      footerLink: [
        {name: "verify certification", url: "https://freecodecamp.org/certification/littleyounes/javascript-algorithms-and-data-structures"},
        
        
      ]
    },
    {
      title: "Apis and Microservices (FreeCodeCamp)",
      subtitle: "Developer Certification, representing approximately 300 hours of coursework.",
      image: require("./assets/images/fcc.png"),
      footerLink: [
        {name: "verify certification", url: "https://freecodecamp.org/certification/littleyounes/javascript-algorithms-and-data-structures"},
        {name: "Projet final 1",
        url: "https://TimeStamp-Fcc.younessrihr.repl.co"
      },
        {name: "Projet final 2",
        url: "https://pale-defiant-heat.glitch.me/"
      }
        
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contactez Moi"),
  subtitle:
    "Pour un éventuel entretien, ou simplement pour des questions n'hésitez pas :)",
  number: "07.68.74.18.02",
  email_address: "ysrhir@hotmail.fr"
};

// Twitter Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  bigProjects2,
  bigProjects3,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
